import type { AwardedCollectible } from '../../services/collection-service';

const RARITY_COLOR: Record<string, string> = {
  common: 'text-body-grey',
  uncommon: 'text-[#2f9440]',
  rare: 'text-teal-ink',
  legendary: 'text-gold-ink',
};

/**
 * The payoff of a redemption: award_collectible_on_redeem grants an item when
 * the burn confirms, and before this existed it landed silently — the customer
 * never saw their collection grow.
 */
export default function CollectibleReveal({ item, onDismiss }: {
  item: AwardedCollectible;
  onDismiss: () => void;
}) {
  return (
    <div
      className="h-full w-full flex flex-col items-center justify-center gap-4 p-4 bg-[rgba(28,25,23,.55)] pixel-corners"
      role="dialog"
      aria-label="New collectible"
    >
      <div className="w-full max-w-xs bg-background pixel-corners p-7 text-center">
        <p className="font-heading text-[8px] text-coral tracking-[1px] mb-3">✦ NEW ITEM ✦</p>
        {item.icon && (
          <img src={item.icon} alt="" className="w-20 h-20 mx-auto mb-3 object-contain [image-rendering:pixelated]" />
        )}
        <p className="font-grotesk font-bold text-xl text-primary">{item.name}</p>
        <p className={`font-grotesk font-medium text-[12px] mt-1 ${RARITY_COLOR[item.rarity] || 'text-body-grey'}`}>
          {item.rarity.toUpperCase()} · PRINT #{item.print_number}
        </p>
        <p className="font-grotesk font-medium text-[11px] text-body-grey mt-3">ADDED TO COLLECTION</p>
      </div>
      <button onClick={onDismiss} className="pixel-corners-sm bg-white text-primary font-grotesk font-bold text-sm py-3 px-6">
        NICE
      </button>
    </div>
  );
}
